import { Meta } from "@angular/platform-browser";

export enum Currency {
    GOLD, SILVER, PLATIN, PALLADIUM, EURO
}

export const currencyList = [
    {
        name: Currency.GOLD,
        label: "GOLD",
        type: "Au",
        icon: "ic-au",
        image: "../../../../assets/image/img_gold.svg",
    },
    {
        name: Currency.SILVER,
        label: "SILVER",
        type: "Ag",
        icon: "ic-ag",
        image: "../../../../assets/image/img_silver.svg",
    },
    {
        name: Currency.PLATIN,
        label: "PLATIN",
        type: "Pt",
        icon: "ic-pt",
        image: "../../../../assets/image/img_platinium.svg",
    },
    {
        name: Currency.PALLADIUM,
        label: "PALLADIUM",
        type: "Pd",
        icon: "ic-pd",
        image: "../../../../assets/image/img_palladium.svg",
    },
    {
        name: Currency.EURO,
        label: "EURO",
        type: "Euro",
        icon: "ic-euro",
        image: "../../../../assets/image/img_euro.svg",
    },

]






